import Chain1030light from '../logos/chain/Chain1030Light.svg';
import Chain146light from '../logos/chain/Chain146Light.svg';
import Chain1868light from '../logos/chain/Chain1868Light.svg';
import Chain196light from '../logos/chain/Chain196Light.svg';
import Chain2001light from '../logos/chain/Chain2001Light.svg';
import Chain252light from '../logos/chain/Chain252Light.svg';
import Chain280light from '../logos/chain/Chain280Light.svg';
import Chain324light from '../logos/chain/Chain324Light.svg';
import Chain325000light from '../logos/chain/Chain325000Light.svg';
import Chain34443light from '../logos/chain/Chain34443Light.svg';
import Chain480light from '../logos/chain/Chain480Light.svg';
import Chain4913light from '../logos/chain/Chain4913Light.svg';
import Chain5000light from '../logos/chain/Chain5000Light.svg';
import Chain5001light from '../logos/chain/Chain5001Light.svg';
import Chain5003light from '../logos/chain/Chain5003Light.svg';
import Chain57054light from '../logos/chain/Chain57054Light.svg';
import Chain59140light from '../logos/chain/Chain59140Light.svg';
import Chain59141light from '../logos/chain/Chain59141Light.svg';
import Chain59144light from '../logos/chain/Chain59144Light.svg';
import Chain60808light from '../logos/chain/Chain60808Light.svg';
import Chain64165light from '../logos/chain/Chain64165Light.svg';
import Chain71light from '../logos/chain/Chain71Light.svg';
import Chain81457light from '../logos/chain/Chain81457Light.svg';
import Chain82light from '../logos/chain/Chain82Light.svg';
import Chain994873017light from '../logos/chain/Chain994873017Light.svg';
import Chain33139 from '../logos/chain/Chain33139.svg';
import Chain33111 from '../logos/chain/Chain33111.svg';
import Chain42161 from '../logos/chain/Chain42161.svg';
import Chain421614 from '../logos/chain/Chain421614.svg';
import Chain2340 from '../logos/chain/Chain2340.svg';
import Chain43114 from '../logos/chain/Chain43114.svg';
import Chain43113 from '../logos/chain/Chain43113.svg';
import Chain8453 from '../logos/chain/Chain8453.svg';
import Chain84532 from '../logos/chain/Chain84532.svg';
import Chain80094 from '../logos/chain/Chain80094.svg';
import Chain80069 from '../logos/chain/Chain80069.svg';
import Chain200901 from '../logos/chain/Chain200901.svg';
import Chain200810 from '../logos/chain/Chain200810.svg';
import Chain81457 from '../logos/chain/Chain81457.svg';
import Chain168587773 from '../logos/chain/Chain168587773.svg';
import Chain60808 from '../logos/chain/Chain60808.svg';
import Chain808813 from '../logos/chain/Chain808813.svg';
import Chain56 from '../logos/chain/Chain56.svg';
import Chain97 from '../logos/chain/Chain97.svg';
import Chain1030 from '../logos/chain/Chain1030.svg';
import Chain71 from '../logos/chain/Chain71.svg';
import Chain1116 from '../logos/chain/Chain1116.svg';
import Chain1115 from '../logos/chain/Chain1115.svg';
import Chain1 from '../logos/chain/Chain1.svg';
import Chain17000 from '../logos/chain/Chain17000.svg';
import Chain11155111 from '../logos/chain/Chain11155111.svg';
import Chain252 from '../logos/chain/Chain252.svg';
import Chain2522 from '../logos/chain/Chain2522.svg';
import Chain100 from '../logos/chain/Chain100.svg';
import Chain10200 from '../logos/chain/Chain10200.svg';
import Chain2525 from '../logos/chain/Chain2525.svg';
import Chain2424 from '../logos/chain/Chain2424.svg';
import Chain57073 from '../logos/chain/Chain57073.svg';
import Chain763373 from '../logos/chain/Chain763373.svg';
import Chain2222 from '../logos/chain/Chain2222.svg';
import Chain2221 from '../logos/chain/Chain2221.svg';
import Chain255 from '../logos/chain/Chain255.svg';
import Chain2358 from '../logos/chain/Chain2358.svg';
import Chain1890 from '../logos/chain/Chain1890.svg';
import Chain1891 from '../logos/chain/Chain1891.svg';
import Chain59144 from '../logos/chain/Chain59144.svg';
import Chain59141 from '../logos/chain/Chain59141.svg';
import Chain994873017 from '../logos/chain/Chain994873017.svg';
import Chain1952959480 from '../logos/chain/Chain1952959480.svg';
import Chain169 from '../logos/chain/Chain169.svg';
import Chain3441006 from '../logos/chain/Chain3441006.svg';
import Chain5000 from '../logos/chain/Chain5000.svg';
import Chain5003 from '../logos/chain/Chain5003.svg';
import Chain6342 from '../logos/chain/Chain6342.svg';
import Chain4200 from '../logos/chain/Chain4200.svg';
import Chain686868 from '../logos/chain/Chain686868.svg';
import Chain1750 from '../logos/chain/Chain1750.svg';
import Chain1088 from '../logos/chain/Chain1088.svg';
import Chain59902 from '../logos/chain/Chain59902.svg';
import Chain34443 from '../logos/chain/Chain34443.svg';
import Chain919 from '../logos/chain/Chain919.svg';
import Chain10143 from '../logos/chain/Chain10143.svg';
import Chain1284 from '../logos/chain/Chain1284.svg';
import Chain1287 from '../logos/chain/Chain1287.svg';
import Chain1285 from '../logos/chain/Chain1285.svg';
import Chain911867 from '../logos/chain/Chain911867.svg';
import Chain4913 from '../logos/chain/Chain4913.svg';
import Chain204 from '../logos/chain/Chain204.svg';
import Chain5611 from '../logos/chain/Chain5611.svg';
import Chain10 from '../logos/chain/Chain10.svg';
import Chain11155420 from '../logos/chain/Chain11155420.svg';
import Chain137 from '../logos/chain/Chain137.svg';
import Chain80002 from '../logos/chain/Chain80002.svg';
import Chain1101 from '../logos/chain/Chain1101.svg';
import Chain2442 from '../logos/chain/Chain2442.svg';
import Chain1380012617 from '../logos/chain/Chain1380012617.svg';
import Chain1918988905 from '../logos/chain/Chain1918988905.svg';
import Chain42402 from '../logos/chain/Chain42402.svg';
import Chain2020 from '../logos/chain/Chain2020.svg';
import Chain2021 from '../logos/chain/Chain2021.svg';
import Chain534352 from '../logos/chain/Chain534352.svg';
import Chain534351 from '../logos/chain/Chain534351.svg';
import Chain1329 from '../logos/chain/Chain1329.svg';
import Chain1328 from '../logos/chain/Chain1328.svg';
import Chain1868 from '../logos/chain/Chain1868.svg';
import Chain1946 from '../logos/chain/Chain1946.svg';
import Chain146 from '../logos/chain/Chain146.svg';
import Chain57054 from '../logos/chain/Chain57054.svg';
import Chain167000 from '../logos/chain/Chain167000.svg';
import Chain167009 from '../logos/chain/Chain167009.svg';
import Chain130 from '../logos/chain/Chain130.svg';
import Chain1301 from '../logos/chain/Chain1301.svg';
import Chain480 from '../logos/chain/Chain480.svg';
import Chain4801 from '../logos/chain/Chain4801.svg';
import Chain196 from '../logos/chain/Chain196.svg';
import Chain195 from '../logos/chain/Chain195.svg';
import Chain48900 from '../logos/chain/Chain48900.svg';
import Chain48899 from '../logos/chain/Chain48899.svg';
import ChainPlaceholder from '../logos/chain/Placeholder.svg';
function sanitizeName(id) {
  return id.replace(/\s+|-/g, '').replace(/ExchangeRate/g, '');
}
function ChainLogo(id, light = false) {
  if (!id) {
    return ChainPlaceholder;
  }
  switch (sanitizeName(`${id}${light ? "light" : ""}`).toLowerCase()) {
    case "1030light":
      return Chain1030light;
    case "146light":
      return Chain146light;
    case "1868light":
      return Chain1868light;
    case "196light":
      return Chain196light;
    case "2001light":
      return Chain2001light;
    case "252light":
      return Chain252light;
    case "280light":
      return Chain280light;
    case "324light":
      return Chain324light;
    case "325000light":
      return Chain325000light;
    case "34443light":
      return Chain34443light;
    case "480light":
      return Chain480light;
    case "4913light":
      return Chain4913light;
    case "5000light":
      return Chain5000light;
    case "5001light":
      return Chain5001light;
    case "5003light":
      return Chain5003light;
    case "57054light":
      return Chain57054light;
    case "59140light":
      return Chain59140light;
    case "59141light":
      return Chain59141light;
    case "59144light":
      return Chain59144light;
    case "60808light":
      return Chain60808light;
    case "64165light":
      return Chain64165light;
    case "71light":
      return Chain71light;
    case "81457light":
      return Chain81457light;
    case "82light":
      return Chain82light;
    case "994873017light":
      return Chain994873017light;
    case "33139":
      return Chain33139;
    case "33111":
      return Chain33111;
    case "42161":
      return Chain42161;
    case "421614":
      return Chain421614;
    case "2340":
      return Chain2340;
    case "43114":
      return Chain43114;
    case "43113":
      return Chain43113;
    case "8453":
      return Chain8453;
    case "84532":
      return Chain84532;
    case "80094":
      return Chain80094;
    case "80069":
      return Chain80069;
    case "200901":
      return Chain200901;
    case "200810":
      return Chain200810;
    case "81457":
      return Chain81457;
    case "168587773":
      return Chain168587773;
    case "60808":
      return Chain60808;
    case "808813":
      return Chain808813;
    case "56":
      return Chain56;
    case "97":
      return Chain97;
    case "1030":
      return Chain1030;
    case "71":
      return Chain71;
    case "1116":
      return Chain1116;
    case "1115":
      return Chain1115;
    case "1":
      return Chain1;
    case "17000":
      return Chain17000;
    case "11155111":
      return Chain11155111;
    case "252":
      return Chain252;
    case "2522":
      return Chain2522;
    case "100":
      return Chain100;
    case "10200":
      return Chain10200;
    case "2525":
      return Chain2525;
    case "2424":
      return Chain2424;
    case "57073":
      return Chain57073;
    case "763373":
      return Chain763373;
    case "2222":
      return Chain2222;
    case "2221":
      return Chain2221;
    case "255":
      return Chain255;
    case "2358":
      return Chain2358;
    case "1890":
      return Chain1890;
    case "1891":
      return Chain1891;
    case "59144":
      return Chain59144;
    case "59141":
      return Chain59141;
    case "994873017":
      return Chain994873017;
    case "1952959480":
      return Chain1952959480;
    case "169":
      return Chain169;
    case "3441006":
      return Chain3441006;
    case "5000":
      return Chain5000;
    case "5003":
      return Chain5003;
    case "6342":
      return Chain6342;
    case "4200":
      return Chain4200;
    case "686868":
      return Chain686868;
    case "1750":
      return Chain1750;
    case "1088":
      return Chain1088;
    case "59902":
      return Chain59902;
    case "34443":
      return Chain34443;
    case "919":
      return Chain919;
    case "10143":
      return Chain10143;
    case "1284":
      return Chain1284;
    case "1287":
      return Chain1287;
    case "1285":
      return Chain1285;
    case "911867":
      return Chain911867;
    case "4913":
      return Chain4913;
    case "204":
      return Chain204;
    case "5611":
      return Chain5611;
    case "10":
      return Chain10;
    case "11155420":
      return Chain11155420;
    case "137":
      return Chain137;
    case "80002":
      return Chain80002;
    case "1101":
      return Chain1101;
    case "2442":
      return Chain2442;
    case "1380012617":
      return Chain1380012617;
    case "1918988905":
      return Chain1918988905;
    case "42402":
      return Chain42402;
    case "2020":
      return Chain2020;
    case "2021":
      return Chain2021;
    case "534352":
      return Chain534352;
    case "534351":
      return Chain534351;
    case "1329":
      return Chain1329;
    case "1328":
      return Chain1328;
    case "1868":
      return Chain1868;
    case "1946":
      return Chain1946;
    case "146":
      return Chain146;
    case "57054":
      return Chain57054;
    case "167000":
      return Chain167000;
    case "167009":
      return Chain167009;
    case "130":
      return Chain130;
    case "1301":
      return Chain1301;
    case "480":
      return Chain480;
    case "4801":
      return Chain4801;
    case "196":
      return Chain196;
    case "195":
      return Chain195;
    case "48900":
      return Chain48900;
    case "48899":
      return Chain48899;
    default:
      return light ? ChainLogo(id) : ChainPlaceholder;
  }
}
export default ChainLogo;